"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var performance = _ref.performance,
      document = _ref.document;
  var HIT = 'hit';
  var match = document.cookie.match(/ssr-caching="cache.desc=(\w+)/);

  if (match) {
    return match[1] === HIT;
  }

  if (performance && performance.getEntriesByType) {
    var navigation = performance.getEntriesByType('navigation')[0];

    if (navigation) {
      var serverTiming = navigation.serverTiming;

      if (serverTiming && serverTiming.length) {
        var cache = serverTiming.find(function (_ref2) {
          var name = _ref2.name;
          return name === 'cache';
        });

        if (cache) {
          return cache.description === HIT;
        }
      }
    }
  }
};

exports["default"] = _default;
//# sourceMappingURL=isCached.js.map